import React, { useEffect, useState } from "react";
import { getDeliveryReqDetailApi } from "../../../../Api/PanelAdminServices";
import { errorToast } from "../../../../Utils/Toast/Toast";
import UserInfoAddress from "../UserInfoAddress/UserInfoAddress";
import RequestInfo from "../RequestInfo/RequestInfo";
import DriverDetail from "../DriverDetail/DriverDetail";
import PaymentSituation from "../PaymentSituation/PaymentSituation";


const DeliveryRequestDetail = ({ requestId }) => {
  const [requestDetailState, setRequestDetailState] = useState();
  useEffect(() => {
    getDetailHandler();
  }, []);
  const getDetailHandler = () => {
    getDeliveryReqDetailApi(requestId, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setRequestDetailState(res.travel);
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };
  return <div>
    <UserInfoAddress title={'اطلاعات مبدا و فرستنده'} info={requestDetailState?.delivery_routes[0]} type="فرستنده"/>
    <UserInfoAddress title={'اطلاعات مقصد و گیرنده'} info={requestDetailState?.delivery_routes[1]} type="گیرنده"/>
    {requestDetailState?.delivery_routes[2]&&<UserInfoAddress title={'اطلاعات مقصد و گیرنده دوم'} info={requestDetailState?.delivery_routes[2]} type="'گیرنده دوم'"/>}
    <RequestInfo info={requestDetailState}/>
    {requestDetailState?.driver_name&&<DriverDetail info={requestDetailState}/>}
    <PaymentSituation info={requestDetailState}/>
  </div>;
};

export default DeliveryRequestDetail;
